/**
 * Règles de détection des trajets et arrêts — UNE définition TypeScript, jumelle de `gps_historique_parametres()` (migration 0057).
 * Le test `historique-gps.test.ts` relit la migration et refuse toute dérive entre les deux.
 * Détail et justification de chaque seuil : `SwiftDeliver/docs/HISTORIQUE-ET-RAPPORTS-GPS.md` § 3.
 */
export interface ParametresDetection {
  /** Un intervalle est « en mouvement » si la vitesse du boîtier à l'arrivée atteint ce seuil (km/h)… */
  vitesse_mouvement_kmh: number
  /** …ou si la vitesse déduite de la distance l'atteint ET que le déplacement fait au moins ceci (m). */
  deplacement_min_m: number
  /** Un arrêt plus court (s) reste dans le trajet (entre deux mouvements) ou n'est pas compté. */
  arret_min_s: number
  /** Un « trajet » de moins de (m) est du bruit ou une manœuvre : il se fond dans l'arrêt qui l'entoure. */
  trajet_min_m: number
  /** Vitesse implicite (km/h) au-delà de laquelle un point isolé est écarté ; une vitesse rapportée au-delà est ignorée. */
  vitesse_aberrante_kmh: number
  /** Écart (s) sans position au-delà duquel un déplacement inexplicable devient « sans signal ». */
  trou_max_s: number
  periode_max_jours: number
  points_max: number
  points_defaut: number
  points_pre_echantillon: number
  /** Écart (s) à partir duquel les deux points qui l'encadrent sont conservés (relevé à 5 fois l'écart médian). */
  pause_s: number
  lieu_rayon_m: number
}

export const PARAMETRES_DETECTION: Readonly<ParametresDetection> = Object.freeze({
  vitesse_mouvement_kmh: 5,
  deplacement_min_m: 30,
  arret_min_s: 180,
  trajet_min_m: 100,
  vitesse_aberrante_kmh: 200,
  trou_max_s: 1800,
  periode_max_jours: 31,
  points_max: 5000,
  points_defaut: 1500,
  points_pre_echantillon: 12000,
  pause_s: 120,
  lieu_rayon_m: 150,
})
